import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { writtenWorks } from '../components/WrittenWorks';

const styles = {
  container: {
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '2rem 0',
    fontFamily: 'Georgia, serif',
  },
  header: {
    textAlign: 'center' as const,
    marginBottom: '3rem',
    borderBottom: '2px solid #ddd',
    paddingBottom: '2rem',
  },
  title: {
    fontSize: '2.5rem',
    marginBottom: '0.5rem',
    color: '#2c3e50',
  },
  subtitle: {
    fontSize: '1.1rem',
    color: '#666',
  },
  listContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2rem',
    justifyContent: 'center',
  },
  workCard: {
    padding: '2rem',
    border: '2px solid #ddd',
    borderRadius: '8px',
    backgroundColor: '#fafafa',
    transition: 'all 0.3s ease',
    margin: '0 2rem',
  },
  workCardHovered: {
    padding: '2rem',
    border: '2px solid #8b7355',
    borderRadius: '8px',
    backgroundColor: '#fafafa',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    margin: '.15rem 2rem',
  },
  workCardTitle: {
    fontSize: '1.5rem',
    marginBottom: '0.5rem',
    color: '#2c3e50',
    margin: 0,
  },
  workCardSubtitle: {
    fontSize: '0.95rem',
    fontStyle: 'italic',
    color: '#666',
    marginBottom: '1rem',
  },
  workCardAuthor: {
    fontSize: '0.9rem',
    color: '#888',
    marginBottom: '1rem',
  },
  workCardDescription: {
    fontSize: '0.95rem',
    color: '#555',
    lineHeight: '1.6',
    marginBottom: '1rem',
  },
  readLink: {
    display: 'inline-block',
    marginTop: '1rem',
    padding: '0.75rem 1.5rem',
    backgroundColor: '#8b7355',
    color: 'white',
    textDecoration: 'none',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.95rem',
    fontWeight: 'bold' as const,
    transition: 'background-color 0.3s ease',
  },
  readLinkHover: {
    backgroundColor: '#6d5845',
  },
} as const;

export default function WrittenWorks(this: any) {
  const [hoveredWork, setHoveredWork] = useState<string | null>(null);
  const [hoveredLink, setHoveredLink] = useState<string | null>(null);

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.title}>Written Works</h1>
        <p style={styles.subtitle}>Explore sermons and writings by Darold H. Morgan</p>
      </header>

      <div style={styles.listContainer}>
        {writtenWorks.map(work => (
          <div
            key={work.id}
            style={hoveredWork === work.id ? styles.workCardHovered : styles.workCard}
            onMouseEnter={() => setHoveredWork(work.id)}
            onMouseLeave={() => setHoveredWork(null)}
          >
            <h2 style={styles.workCardTitle}>{work.title}</h2>
            <p style={styles.workCardSubtitle}>{work.subtitle}</p>
            <p style={styles.workCardAuthor}>
              <strong>By</strong> {work.author}<br />
              <strong>Church:</strong> {work.church}
            </p>
            <p style={styles.workCardDescription}>{work.description}</p>
            <Link
              to={`/written-works/${work.id}`}
              style={hoveredLink === work.id ? { ...styles.readLink, ...styles.readLinkHover } : styles.readLink}
              onMouseEnter={() => setHoveredLink(work.id)}
              onMouseLeave={() => setHoveredLink(null)}
            >
              Read Full Text →
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}